import clsx from 'clsx';
import { useTranslation } from 'next-i18next/pages';
import { twMerge } from 'tailwind-merge';

import { ReactComponent as Icon } from '@pflegia/ui/icons/spinner.svg';

const DEFAULT_SIZE = 40;

type SpinnerProps = React.SVGProps<SVGSVGElement> & {
  containerClassName?: string;
  title?: string | undefined;
};

const Spinner: React.FC<SpinnerProps> = ({ className, containerClassName, height, title, ...rest }) => {
  const { t } = useTranslation('common');
  return (
    <div className={twMerge(clsx('flex grow items-center justify-center', containerClassName))}>
      <Icon
        {...rest}
        className={twMerge(clsx('text-primary mx-auto aspect-square animate-spin', className))}
        height={height ?? DEFAULT_SIZE}
        title={title ?? t('loading')}
      />
    </div>
  );
};

export default Spinner;
